const mutations = {
  onPost (state, payload) {
    payload.event.context.showSuccess = true
    if (payload.event.context.registration.method === 'bank_account') {
      let link = payload.response.data.data.subscription.subscriptions_charge.openpay_charge.receipt_url
      payload.event.context.sandboxLink = link
    }
    payload.event.context.showNotification(payload.response.data.message, 'success')
  },
  onGetInformation (state, payload) {
    let subscription =  payload.response.data.data
    subscription.msg2 = subscription.msg2.substring(0, subscription.msg2.length - 1)
    payload.event.context.subscription = subscription
  },
  onGetPlans(state, payload) {
    payload.event.context.plans = payload.response.data.data
  },
}

export default mutations